const tabClassName = (isSelected) => isSelected
    ? 'whitespace-nowrap px-5 text-xs py-2 rounded-lg transition bg-white shadow-sm text-[#1d1d1f]'
    : 'whitespace-nowrap px-5 text-xs py-2 rounded-lg transition text-gray-500';

export default function AdjustmentGroupTabs({ groups, selectedGroup, onSelectGroup }) {

    return (
        <div className="mb-5 max-w-full overflow-x-auto">
            <div className="inline-flex gap-1 p-1 rounded-xl bg-[#f2f2f2]">
                {groups.map(group => (
                    <button
                        key={group.key}
                        type="button"
                        onClick={() => onSelectGroup(group.key)}
                        className={tabClassName(selectedGroup === group.key)}
                    >
                        {group.label}
                    </button>
                ))}
            </div>
        </div>
    );
}
